<template>
    <div class="animated fadeIn efficiency">
        <filters :scope="filtersScope">
        </filters>
        <modal small title="" v-model="confirmModal" effect="fade/zoom">
          <div slot="modal-header" class="modal-header">
            <div style="font-size: 1.5em;text-align: center;">{{ $t('verbs.edit') }}</div>
          </div>
          <div style="text-align: center;">
            <button type="button" class="btn btn-outline-info" @click="confirmValue(true)">
              {{ $t('verbs.apply') }}
            </button>
            <button type="button" class="btn btn-outline-info" @click="confirmValue(false)">
              {{ $t('verbs.close') }}
            </button>
          </div>
          <div slot="modal-footer" class="modal-footer">
          </div>
        </modal>

        <form @submit="checkForm" id="formRent">
          <div class="card">
            <div class="card-block">
              <div class="row">
                <div class="col-md-3">
                  <table class="table">
                    <tbody>
                      <tr>
                        <td class="cel"><strong>КЦ</strong> {{ reskc }}</td>
                        <td class="cel"><strong>Доставка</strong> {{ resdoc }}</td>
                        <td class="cel"><strong>Возвраты</strong> {{ resVozv }}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>
                <div class="col-md-3"></div>
                <div class="col-md-3"></div>
                <div class="col-md-3">
                  <div class="row">
                    <div class="col-md-6"></div>
                    <div class="col-md-6 apply-buttons">
                      <button class="btn btn-success btn-lg">
                        <i class="fa fa-check-circle"></i>
                        Сохранить
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <StatisticTable :headColumns="headColumns"
                          :footColumns="footColumns"
                          :rows="rows"
                          ref="statisticTable"
                          @changeElem="changeElem"
                          :title="`${$t('pages.offer_rent')}`">
          </StatisticTable>
        </form>
    </div>
</template>

<script>
  import Filters from '../../../components/Filters.vue'
  import API from '../../../api/API'
  import Storage from '../../../api/Storage'
  import { map, orderBy } from 'lodash'
  import { modal } from 'vue-strap'
  import Helper from '../../../api/Helper'
  import TypeColor from '../../../assets/TypeColor'
  import StatisticTable from '../../../components/StatisticTable.vue'

  export default {
    name: 'Rentability',
    components: {
      Filters,
      StatisticTable,
      modal
    },
    data () {
      return {
        filtersScope: {
          countryFilter: true,
          dateFilter: true,
          offerFilter: true,
          byWmFilter: true,
          oneCountryFilter: true
        },
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        confirmModal: false,
        reskc: 0,
        resdoc: 0,
        resVozv: 0,
        oldValue: {},
        ChangeValue: String,
        headColumns: [
          {label: this.$root.$t('statistic.offer'), field: 'offer'},
          {label: this.$root.$t('statistic.vat'), field: 'vat'},
          {label: this.$root.$t('statistic.out'), field: 'out'},
          {label: this.$root.$t('statistic.packaging'), field: 'packaging'},
          {label: this.$root.$t('statistic.price_for_one'), field: 'price_for_one', width: '60px'},
          {label: this.$root.$t('statistic.averageBill'), field: 'average_bill', colspan: 2},
          {label: this.$root.$t('statistic.buyout'), field: 'buyout'},
          {label: this.$root.$t('statistic.shippeds'), field: 'shipped'},
          {label: this.$root.$t('statistic.average_payments'), field: 'average_payments'},
          {label: this.$root.$t('statistic.profitlid'), field: 'profit_for_one'},
          {label: this.$root.$t('statistic.profitperiod'), field: 'profit_for_period'}
        ],
        rows: [],
        footColumns: {}
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      getApi () {
        return new Promise(function (resolve, reject) {
          let statistic = {}
          API.getOfferRentabilityStatistic().then(response => {
            if (response.status === 200) {
              statistic = response.body
              statistic.status = response.status
              resolve(statistic)
            }
          }).catch(error => {
            reject(error)
          })
        })
      },
      checkForm: function (e) {
        let post = {}
        let idnum
        map(e.target.elements, elem => {
          if (elem.name) {
            idnum = elem.id.substring(1)
            if (!post[idnum]) {
              post[idnum] = []
            }
            post[idnum].push({[elem.name]: elem.value})
          }
        })
        API.postEditOfferRentability(post).then(response => {
          if (response.status === 200) {
            this.calculateRows()
          }
        }).catch(error => {
          console.log('Ошибка в запросе', error)
        })
        // console.log(JSON.stringify(post))
        e.preventDefault()
      },
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        let max = {
          average_x_price: 0,
          average_bill: 0,
          profit_for_one: 0,
          profit_for_period: 0
        }
        let min = {
          profit_for_one: 0,
          profit_for_period: 0
        }
        let statistic = {}
        let expenses = {}
        this.getApi()
              .then(statisticBek => {
                expenses = statisticBek.expenses
                if (Storage.selectedCountry.id === 77 || Storage.selectedCountry.id === 1535 || Storage.selectedCountry.id === 1547) {
                  this.reskc = `${(expenses.call_centre).toFixed(2)}₽`
                  this.resdoc = `${(expenses.ship).toFixed(2)}₽`
                  this.resVozv = `${(expenses.return).toFixed(2)}₽`
                } else {
                  this.reskc = `${(expenses.call_centre).toFixed(2)}$`
                  this.resdoc = `${(expenses.ship).toFixed(2)}$`
                  this.resVozv = `${(expenses.return).toFixed(2)}$`
                }
                statistic = statisticBek.statistic
                let sumVat = 0
                let countVat = 0
                let sumOut = 0
                let countOut = 0
                let sumPack = 0
                let countPack = 0
                let sumAverageBill = 0
                let countAverageBill = 0
                let sumAverageXPrice = 0
                let countAverageXPrice = 0
                let sumBuyout = 0
                let countBuyout = 0
                let sumPrice = 0
                let countPrice = 0
                let sumShip = 0
                let countShip = 0
                let sumProfPer = 0
                let sumApproved = 0
                let sumAveragePayment = 0
                let countAveragePayment = 0
                let colorProf = '#fff'
                let colorProfT = '#000'
                let colorProfPer = '#fff'
                let colorProfPerT = '#000'
                map(statistic, (offer, offerid) => {
                  offer.average_x_price = Helper.getxstart(offer.average_bill, offer.average_start_price)
                  offer.average_payment = parseFloat(offer.average_payment).toFixed(1)
                  if (parseFloat(max.average_x_price) < parseFloat(offer.average_x_price)) {
                    max.average_x_price = parseFloat(offer.average_x_price)
                  }
                  if (parseFloat(max.average_bill) < parseFloat(offer.average_bill)) {
                    max.average_bill = parseFloat(offer.average_bill)
                  }
                  if (parseFloat(max.profit_for_one) < parseFloat(offer.profit_for_one)) {
                    max.profit_for_one = parseFloat(offer.profit_for_one)
                    offer.red = 0
                  }
                  if (parseFloat(min.profit_for_one) > parseFloat(offer.profit_for_one)) {
                    min.profit_for_one = parseFloat(offer.profit_for_one)
                  }
                  if (parseFloat(max.profit_for_period) < parseFloat(offer.profit_for_period)) {
                    max.profit_for_period = parseFloat(offer.profit_for_period)
                  }
                  if (parseFloat(min.profit_for_period) > parseFloat(offer.profit_for_period)) {
                    min.profit_for_period = parseFloat(offer.profit_for_period)
                  }
                  if (offer.vat > 0) {
                    sumVat += parseFloat(offer.vat)
                    countVat++
                  }
                  if (offer.out > 0) {
                    sumOut += parseFloat(offer.out)
                    countOut++
                  }
                  if (offer.packaging > 0) {
                    sumPack += parseFloat(offer.packaging)
                    countPack++
                  }
                  if (offer.average_bill > 0) {
                    sumAverageBill += parseFloat(offer.average_bill)
                    countAverageBill++
                  }
                  if (offer.average_x_price > 0) {
                    sumAverageXPrice += parseFloat(offer.average_x_price)
                    countAverageXPrice++
                  }
                  if (offer.shipped > 0) {
                    sumShip += parseInt(Helper.percents(offer.approved, offer.shipped))
                    countShip++
                  }
                  if (offer.average_payment > 0) {
                    sumAveragePayment += parseInt(offer.average_payment)
                    countAveragePayment++
                  }
                  if (offer.buyout > 0) {
                    sumBuyout += parseFloat(Helper.percents(offer.approved, offer.buyout))
                    countBuyout++
                  }
                  if (offer.profit_for_period !== 0) {
                    sumProfPer += parseInt(offer.profit_for_period)
                  }
                  if (offer.price_for_one !== 0) {
                    sumPrice += parseInt(offer.price_for_one)
                    countPrice++
                  }
                  if (offer.approved !== 0) {
                    sumApproved += parseInt(offer.approved)
                  }
                })
                if (sumProfPer > 0) {
                  colorProfPer = '#c8e6c9'
                  colorProfPerT = '#4f874f'
                } else {
                  colorProfPer = '#ef9a9a'
                  colorProfPerT = '#a54949'
                }
                if (parseFloat(sumProfPer / sumApproved) > 0) {
                  colorProf = '#c8e6c9'
                  colorProfT = '#4f874f'
                } else {
                  colorProf = '#ef9a9a'
                  colorProfT = '#a54949'
                }
                map(statistic, (d, id) => {
                  if (Storage.selectedCountry.id === 77 || Storage.selectedCountry.id === 1535 || Storage.selectedCountry.id === 1547) {
                    this.rows.push({
                      offer: {value: Helper.getOfferTitle(Storage.offers, id)},
                      vat: {
                        htmlValue: '<input class="cellInput" id="v' + id + '" name="vat" type="text" onchange="" value="' + d.vat + '" >',
                        id: id,
                        oldvalue: d.vat,
                        name: 'vat',
                        notupdate: true,
                        orderData: parseInt(d.vat)
                      },
                      out: {
                        htmlValue: '<input class="cellInput" id="o' + id + '" name="out" type="text" onchange="" value="' + d.out + '" >',
                        id: id,
                        oldvalue: d.out,
                        name: 'out',
                        notupdate: true,
                        orderData: parseInt(d.out)
                      },
                      packaging: {
                        htmlValue: '<input class="cellInput" id="p' + id + '"  name="packaging" type="text" onchange="" value="' + d.packaging + '" >',
                        id: id,
                        oldvalue: d.packaging,
                        name: 'packaging',
                        notupdate: true,
                        orderData: parseFloat(d.packaging)
                      },
                      price_for_one: {
                        value: parseFloat(d.price_for_one).toFixed(2),
                        isCollspaned: true,
                        orderData: parseFloat(d.price_for_one)
                      },
                      average_bill: {
                        value: `${d.average_bill.toFixed(2)}₽`,
                        bgg: Helper.renderSingleGist(max.average_bill, d.average_bill),
                        isCollspaned: true,
                        orderData: parseFloat(d.average_bill)
                      },
                      average_x_price2: {
                        value: `x${parseFloat(d.average_x_price)}`,
                        isCollspaned: true,
                        orderData: parseFloat(d.average_x_price)
                      },
                      buyout: {
                        value: Helper.percents(d.approved, d.buyout),
                        bgg: Helper.renderSingleGist(d.approved, d.buyout),
                        isCollspaned: true,
                        approved: d.approved,
                        orderData: parseFloat(d.approved / d.buyout)
                      },
                      shipped: {
                        value: Helper.percents(d.approved, d.shipped),
                        bgg: Helper.renderSingleGist(d.approved, d.shipped),
                        isCollspaned: true,
                        orderData: parseFloat(d.approved / d.shipped)
                      },
                      average_payments: {
                        value: `${parseFloat(d.average_payment)} ₽`,
                        bg: true,
                        orderData: parseFloat(d.average_payment)
                      },
                      profit_for_one: {
                        value: `${parseFloat(d.profit_for_one).toFixed(2)} ₽`,
                        bgColorTwo: {
                          max: {
                            value: max.profit_for_one,
                            color: '#c8e6c9'
                          },
                          min: {
                            value: min.profit_for_one,
                            color: '#ef9a9a'
                          },
                          value: d.profit_for_one
                        },
                        orderData: parseFloat(d.profit_for_one)
                      },
                      profit_for_period: {
                        value: `${parseInt(d.profit_for_period)} ₽`,
                        bgColorTwo: {
                          max: {
                            value: max.profit_for_period,
                            color: '#c8e6c9'
                          },
                          min: {
                            value: min.profit_for_period,
                            color: '#ef9a9a'
                          },
                          value: d.profit_for_period
                        },
                        orderData: parseInt(d.profit_for_period)
                      }
                    })
                  } else {
                    this.rows.push({
                      offer: {value: Helper.getOfferTitle(Storage.offers, id)},
                      vat: {
                        htmlValue: '<input class="cellInput" id="v' + id + '" name="vat" type="text" onchange="" value="' + d.vat + '" >',
                        id: id,
                        oldvalue: d.vat,
                        name: 'vat',
                        notupdate: true,
                        orderData: parseInt(d.vat)
                      },
                      out: {
                        htmlValue: '<input class="cellInput" id="o' + id + '" name="out" type="text" onchange="" value="' + d.out + '" >',
                        id: id,
                        oldvalue: d.out,
                        name: 'out',
                        notupdate: true,
                        orderData: parseInt(d.out)
                      },
                      packaging: {
                        htmlValue: '<input class="cellInput" id="p' + id + '"  name="packaging" type="text" onchange="" value="' + d.packaging + '" >',
                        id: id,
                        oldvalue: d.packaging,
                        name: 'packaging',
                        notupdate: true,
                        orderData: parseFloat(d.packaging)
                      },
                      price_for_one: {
                        value: parseFloat(d.price_for_one).toFixed(2),
                        isCollspaned: true,
                        orderData: parseFloat(d.price_for_one)
                      },
                      average_bill: {
                        value: '$ ' + d.average_bill.toFixed(2),
                        bgg: Helper.renderSingleGist(max.average_bill, d.average_bill),
                        isCollspaned: true,
                        orderData: parseFloat(d.average_bill)
                      },
                      average_x_price2: {
                        value: `x${parseFloat(d.average_x_price)}`,
                        isCollspaned: true,
                        orderData: parseFloat(d.average_x_price)
                      },
                      buyout: {
                        value: Helper.percents(d.approved, d.buyout),
                        bgg: Helper.renderSingleGist(d.approved, d.buyout),
                        isCollspaned: true,
                        approved: d.approved,
                        orderData: parseFloat(d.approved / d.buyout)
                      },
                      shipped: {
                        value: Helper.percents(d.approved, d.shipped),
                        bgg: Helper.renderSingleGist(d.approved, d.shipped),
                        isCollspaned: true,
                        orderData: parseFloat(d.approved / d.shipped)
                      },
                      average_payments: {
                        value: `${parseFloat(d.average_payment)} $`,
                        bg: true,
                        orderData: parseFloat(d.average_payment)
                      },
                      profit_for_one: {
                        value: `${parseFloat(d.profit_for_one).toFixed(2)} $`,
                        bgColorTwo: {
                          max: {
                            value: max.profit_for_one,
                            color: '#c8e6c9'
                          },
                          min: {
                            value: min.profit_for_one,
                            color: '#ef9a9a'
                          },
                          value: d.profit_for_one
                        },
                        orderData: parseFloat(d.profit_for_one)
                      },
                      profit_for_period: {
                        value: `${parseInt(d.profit_for_period)} $`,
                        bgColorTwo: {
                          max: {
                            value: max.profit_for_period,
                            color: '#c8e6c9'
                          },
                          min: {
                            value: min.profit_for_period,
                            color: '#ef9a9a'
                          },
                          value: d.profit_for_period
                        },
                        orderData: parseInt(d.profit_for_period)
                      }
                    })
                  }
                })
                this.rows = orderBy(this.rows, [(item) => { return parseInt(item['buyout'].approved) }], ['desc'])
                if (Storage.selectedCountry.id === 77 || Storage.selectedCountry.id === 1535 || Storage.selectedCountry.id === 1547) {
                  this.footColumns = {
                    label: {
                      value: this.$root.$t('statistic.in_total')
                    },
                    vat: {
                      value: `${Helper.average(sumVat, countVat)} %`,
                      isCollspaned: true
                    },
                    out: {
                      value: `${Helper.average(sumOut, countOut)} %`,
                      bg: true
                    },
                    packaging: {
                      value: `${parseFloat(sumPack / countPack).toFixed(2)} $`,
                      bg: true
                    },
                    price_for_one: {
                      value: parseFloat(sumPrice / countPrice).toFixed(1),
                      bg: true
                    },
                    average_bill: {
                      value: `${Helper.average(sumAverageBill, countAverageBill)}₽`,
                      grbgaph: true
                    },
                    average_x_price2: {
                      value: `x${parseFloat(sumAverageXPrice / countAverageXPrice).toFixed(2)}`,
                      isCollspaned: true
                    },
                    buyout: {
                      value: `${Helper.average(sumBuyout, countBuyout)} %`,
                      bg: true
                    },
                    shipped: {
                      value: `${Helper.average(sumShip, countShip)} %`,
                      bg: true
                    },
                    average_payments: {
                      value: `${Helper.average(sumAveragePayment, countAveragePayment)} ₽`,
                      bg: true
                    },
                    profit_for_one: {
                      value: `${Helper.averageFloat(sumProfPer, sumApproved)} ₽`,
                      bc: colorProf,
                      c: colorProfT
                    },
                    profit_for_period: {
                      value: `${sumProfPer} ₽`,
                      bc: colorProfPer,
                      c: colorProfPerT
                    }
                  }
                } else {
                  this.footColumns = {
                    label: {
                      value: this.$root.$t('statistic.in_total')
                    },
                    vat: {
                      value: `${Helper.average(sumVat, countVat)} %`,
                      isCollspaned: true
                    },
                    out: {
                      value: `${Helper.average(sumOut, countOut)} %`,
                      bg: true
                    },
                    packaging: {
                      value: `${parseFloat(sumPack / countPack).toFixed(2)} $`,
                      bg: true
                    },
                    price_for_one: {
                      value: parseFloat(sumPrice / countPrice).toFixed(1),
                      bg: true
                    },
                    average_bill: {
                      value: '$ ' + (sumAverageBill / countAverageBill).toFixed(2),
                      grbgaph: true
                    },
                    average_x_price2: {
                      value: `x${parseFloat(sumAverageXPrice / countAverageXPrice).toFixed(2)}`,
                      isCollspaned: true
                    },
                    buyout: {
                      value: `${Helper.average(sumBuyout, countBuyout)} %`,
                      bg: true
                    },
                    shipped: {
                      value: `${Helper.average(sumShip, countShip)} %`,
                      bg: true
                    },
                    average_payments: {
                      value: `${Helper.average(sumAveragePayment, countAveragePayment)} $`,
                      bg: true
                    },
                    profit_for_one: {
                      value: `${Helper.averageFloat(sumProfPer, sumApproved)} $`,
                      bc: colorProf,
                      c: colorProfT
                    },
                    profit_for_period: {
                      value: `${sumProfPer} $`,
                      bc: colorProfPer,
                      c: colorProfPerT
                    }
                  }
                }
                this.$root.$emit('data_loaded')
              })
              .catch(response => {
                this.$root.$emit('data_loaded')
                this.$notify({
                  type: 'danger',
                  title: this.$root.$t('verbs.error'),
                  text: !response.body.message ? response.body : response.body.message,
                  animationType: 'velocity'
                })
              })
      },
      changeElem (cell, value) {
        if (!cell.notupdate) {
          this.confirmModal = true
          this.oldValue = cell
          this.ChangeValue = value
        }
      },
      confirmValue (valueBool) {
        if (valueBool) {
          if (this.oldValue.name === 'vat') {
            API.getOfferRentabilityСhangeStatisticVAT(this.oldValue.id, this.ChangeValue).then(response => {
              this.calculateRows()
            })
          }
          if (this.oldValue.name === 'out') {
            API.getOfferRentabilityСhangeStatisticOUT(this.oldValue.id, this.ChangeValue).then(response => {
              this.calculateRows()
            })
          }
          if (this.oldValue.name === 'packaging') {
            API.getOfferRentabilityСhangeStatisticPACK(this.oldValue.id, this.ChangeValue).then(response => {
              this.calculateRows()
            })
          }
        } else {
          this.calculateRows()
        }
        this.confirmModal = false
      }
    }
  }
</script>

<style>
.cellInput{
  border:none;
  background: transparent;
  text-align: center
}
.cellInput:focus{
    text-align: left;
}
.cel{
  border: rgba(0, 0, 0, 0.03) 2px solid;
}
</style>



// WEBPACK FOOTER //
// Rentability.vue?3624e084